import React, { useState } from "react";
import { useEffect } from "react";
import { FaSearchLocation } from "react-icons/fa";
import { FcHome, FcLockLandscape, FcMindMap } from "react-icons/fc";
import {
  getBillingDetails,
  setBillingDetails,
} from "../../actions/storeActions";

const DeliveryDetail = () => {
  const [deliveryDetail, setDeliveryDetail] = useState({
    brgy: "Bantigue",
    name: "Customer",
    number: "09xxxxxxxxx",
    district: "Carabalias",
  });
  const [disabled, setDisabled] = useState(true);
  const [edit, setEdit] = useState(false);
  const handleDeliveryDetail = (e) => {
    setDeliveryDetail({ ...deliveryDetail, [e.target.name]: e.target.value });
  };
  const handleEdit = async () => {
    setEdit((prev) => !prev);
    await setBillingDetails(deliveryDetail);
  };
  useEffect(() => {
    (async function getTheBillingDetail() {
      const data = await getBillingDetails();

      if (data?.param === "error") {
        setDeliveryDetail({
          brgy: "Bantigue",
          name: "Customer",
          number: "09xxxxxxxxx",
          district: "Carabalias",
        });
      } else if (data?.param === "NoToken" || data?.param === "InvalidToken") {
        setDeliveryDetail({
          brgy: "Bantigue",
          name: "Customer",
          number: "09xxxxxxxxx",
          district: "Carabalias",
        });
      } else {
        const { brgy, number, name, district } = data;
        setDeliveryDetail({ brgy, number, name, district });
        setDisabled(false);
      }
    })();
  }, []);

  return (
    <>
      <div className="detail_container">
        <div className="detail_header_edit">
          <p className="detail_header">Shipping and Billing to</p>
          <button
            className="detail_edit_btn"
            disabled={disabled}
            onClick={() => handleEdit()}
          >
            {edit ? "Save" : "Edit"}
          </button>
        </div>
        <div className="detail">
          {edit ? (
            <input
              type="text"
              placeholder="Name"
              name="name"
              value={deliveryDetail.name}
              onChange={(e) => handleDeliveryDetail(e)}
            />
          ) : (
            <span>{deliveryDetail.name}</span>
          )}
          {edit ? (
            <select
              name="district"
              id=""
              value={deliveryDetail.district}
              onChange={(e) => handleDeliveryDetail(e)}
              className="district"
            >
              <option value="">District</option>
              <option value="Bansikol">Purok Bansikol</option>
              <option value="Carabalias">Purok Carabalias</option>
              <option value="Liplipan">Purok Liplipan</option>
            </select>
          ) : (
            <span>{deliveryDetail.district}</span>
          )}
          {edit ? (
            <select
              name="brgy"
              id=""
              value={deliveryDetail.brgy}
              onChange={(e) => handleDeliveryDetail(e)}
              className="brgy"
            >
              <option value="">Barangay</option>
              <option value="Bantigue">Bantigue Hilongos, Leyte</option>
            </select>
          ) : (
            <span>{deliveryDetail.brgy}</span>
          )}

          {edit ? (
            <input
              type="number"
              name="number"
              id=""
              placeholder="Number"
              value={deliveryDetail.number}
              maxLength={11}
              onChange={(e) => handleDeliveryDetail(e)}
            />
          ) : (
            <span>{deliveryDetail.number}</span>
          )}
        </div>
        {/* <span className="location">
          <FcHome /> Bantigue Hilongos, Leyte
        </span> */}
        {/* <fieldset className="message_container">
        <legend>Message</legend>
        <textarea type="text" name="" id="" />
      </fieldset>
      <fieldset className="voucher_container">
        <legend>Voucher</legend>
        <input type="text" name="" id="" />
        <button className="voucher_btn">USE</button>
      </fieldset> */}

        {/* <div className="rate_container">
        <h2>Rate</h2>
        <p>Standard delivery </p>
        <p>₱50</p>
      </div> */}
      </div>
    </>
  );
};

export default DeliveryDetail;
